export default __webpack_public_path__ + "img/2.2996ab8a.png";